/** @jsx jsx */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { useCommentContext } from './CommentContextProvider.tsx';

// TODO https://product-fabric.atlassian.net/browse/FS-4202
// Ideally we would style the Reactions component itself, but currently
// AK doesn't allow us to do it. So we're wrapping the component on this div
// and pulling it to the left as much as we can without covering the item separator (".")
// we're also giving it a specific height so the item separator will be properly aligned.
const AkCommentAvatarWrapper = ({ children }: PropsWithChildren) => {
	const { isThreadedCommentsEnabled, hasReplies, isReplyingToComment, isDeleted } =
		useCommentContext();

	const showLinesOnRoot = (hasReplies || isReplyingToComment) ?? false;
	const isDeletedComment = isDeleted || false;

	if (isThreadedCommentsEnabled) {
		return (
			<div
				css={[
					profileCardRootStyles,
					profileCardWrapperStyles,
					showLinesOnRoot && rootCommentStyles,
					showLinesOnRoot && rootCommentStylesOverride,

					isDeletedComment && deletedCommentStyles,
				]}
			>
				{children}
			</div>
		);
	}
	return <div css={profileCardRootStyles}>{children}</div>;
};

export default AkCommentAvatarWrapper;

const profileCardRootStyles = css({
	paddingTop: token('space.075'),
});

const profileCardWrapperStyles = css({
	position: 'relative',
	'--commentsLineWidth': '1px',
	'--commentLineColor': token('color.background.accent.gray.subtler'),
	height: '100%',
});
const rootCommentStyles = css({
	'&::before': {
		content: '',
		position: 'absolute',
		insetInlineStart: 'calc(50% - var(--commentsLineWidth)/2)',
		bottom: token('space.0'),
		width: 'var(--commentsLineWidth)',
		top: '46.5px', // From top = 2(padding) + 32(avatar) + 8(padding) + 4.5px
		backgroundColor: 'var(--commentLineColor)',
	},
});
const rootCommentStylesOverride = css({
	'&::before': {
		top: '52.5px',
	},
});
const deletedCommentStyles = css({
	marginBottom: token('space.150'),
});
